module.exports = __webpack_public_path__ + "img/no-data-found-136px.a6b2ecf.png";